
























































import { Component, Vue, Watch } from 'vue-property-decorator';
import GoodsInfo from './goodsInfo.vue';
import { getBackClassifyList, backendCheck } from '@/utils/api';

@Component({
  components: {
    GoodsInfo
  }
})
export default class GoodsAddition extends Vue {
  loading: boolean = false; //记载框
  options: Array<object> = []; //类目列表
  list: Array<object> = []; //合并类目列表
  categoryId: Array<number> = []; //类目id
  supplierName: string = ''; //类目名称
  selectedName: string = ''; //已选择类目名称
  categoryName: Array<string> = []; //三级类目名称
  categories: object = {}; //类目数据传递给子组件
  noSearch: boolean = false; //是否搜索到数据
  isShowCategory: boolean = true; //是否展示平台类目
  $refs: any;

  @Watch('$route', { immediate: true, deep: true })
  routerChange(newVal) {
    console.log(newVal);
    if (newVal['fullPath'] == '/goods/goodsAddition/goodsAddition') {
      this.isShowCategory = true;
      this.init();
      this.$nextTick(() => {
        this.$refs.goodsInfo.init();
      });
    }
  }

  mounted() {
    this.getBackClassifyList();
    this.quilInfo();
  }
  /* 类目接口 */
  getBackClassifyList() {
    this.loading = true;
    getBackClassifyList()
      .then((data: any) => {
        this.options = data;
        let list = [];
        data.forEach((element: any) => {
          element.childs.forEach(el => {
            el.childs.forEach(val => {
              list.push({ value: element.name + ' > ' + el.name + ' > ' + val.name, id: [element.id, el.id, val.id] });
            });
          });
        });
        this.list = list;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  /* 搜索 */
  querySearchAsync(queryString, cb) {
    let restaurants = this.list;
    let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
    // 调用 callback 返回建议列表的数据
    if (results.length == 0) {
      this.noSearch = true;
    } else {
      this.noSearch = false;
    }
    cb(results);
  }
  createFilter(queryString) {
    return restaurant => {
      return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1;
    };
  }
  /* 选择完毕 */
  category(val) {
    let value =
      this.$refs['categoryList'].getCheckedNodes()[0].pathLabels[0] +
      ' > ' +
      this.$refs['categoryList'].getCheckedNodes()[0].pathLabels[1] +
      ' > ' +
      this.$refs['categoryList'].getCheckedNodes()[0].pathLabels[2];
    this.supplierName = value;
    this.noSearch = false;
    this.selectedName = value;
    this.categoryName = [
      this.$refs['categoryList'].getCheckedNodes()[0].pathLabels[0],
      this.$refs['categoryList'].getCheckedNodes()[0].pathLabels[1],
      this.$refs['categoryList'].getCheckedNodes()[0].pathLabels[2]
    ];
  }
  /* 点击选择类目 */
  handleSelect(item) {
    this.categoryId = item.id;
    this.supplierName = item.value;
    this.selectedName = item.value;
    this.categoryName = item.value.split(' > ');
  }
  /* 下一步 */
  nextStep() {
    let categoryId = this.categoryId;
    this.backendCheck(categoryId[2]);
  }
  /* 修改类目传递过来的参数 */
  modifyCategory(val) {
    this.isShowCategory = val.isShowCategory;
    this.categoryName = val.categoryName;
    this.selectedName = val.selectedName;
    this.categoryId = val.categoryId;
    this.supplierName = val.selectedName;
  }
  /* 类目是否存在 */
  backendCheck(catThreeId) {
    backendCheck({ catThreeId }).then((data: any) => {
      if (data) {
        let categoryName = this.categoryName;
        let selectedName = this.selectedName;
        let categoryId = this.categoryId;
        this.categories = { categoryName, selectedName, categoryId };
        this.isShowCategory = false;
        this.quilInfo();
      } else {
        this.$message.error('您选择的类目未授权，请选择其他类目');
        this.getBackClassifyList();
        this.init();
      }
    });
  }
  /* 清空富文本和判断是否为编辑模式 */
  quilInfo() {
    let spuId = this.$route.query.spuid;
    if (spuId) {
      this.isShowCategory = false;
    } else {
      this.$store.commit('INFO', '');
    }
  }
  /* 初始数据为空 */
  init() {
    this.categoryName = [];
    this.selectedName = '';
    this.categoryId = [];
    this.supplierName = '';
    this.categories = {};
  }
  /* 搜索文字高亮为蓝色 */
  brightenKeyword(val, keyword) {
    const Reg = new RegExp(keyword, 'i');
    if (val) {
      return val.replace(Reg, `<span style="color: #1890FF;">${keyword}</span>`);
    }
  }
}
